// extracted by mini-css-extract-plugin
module.exports = {"trigger":"styles_trigger__5wIc_","triggerContent":"styles_triggerContent__ijMG0"};